var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.375C4.65076 17.375 1.125 13.8492 1.125 9.5C1.125 5.15076 4.65076 1.625 9 1.625C13.3492 1.625 16.875 5.15076 16.875 9.5C16.875 13.8492 13.3492 17.375 9 17.375ZM9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z",
    fill: "#C52A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87673 12.875C7.87673 12.2537 8.38041 11.75 9.00173 11.75C9.62305 11.75 10.1267 12.2537 10.1267 12.875C10.1267 13.4963 9.62305 14 9.00173 14C8.38041 14 7.87673 13.4963 7.87673 12.875Z",
    fill: "#C52A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98694 6.11942C7.92701 5.52007 8.39766 5 9 5C9.60234 5 10.073 5.52007 10.0131 6.11942L9.61847 10.0653C9.5867 10.383 9.31933 10.625 9 10.625C8.68067 10.625 8.4133 10.383 8.38153 10.0653L7.98694 6.11942Z",
    fill: "#C52A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4e7f00ceda4c83742fabe87e9a78981b.svg";
export { ForwardRef as ReactComponent };